import { create } from "zustand";
import { initialState, TDisclosureStore } from "./disclosure.state";
import { createDisclosureActions } from "./disclosure.actions";

/**
 * State management store of the V3 search - Disclosures metadata
 * @example
 * ```
 * const disclosures = useDisclosureStore((state) => state.disclosures)
 * const dispatch = useDisclosureStore((state) => state.dispatch)
 * dispatch({ type: SearchActions.SET_DISCLOSURE_ITEMS, payload: disclosuresList })
 * ```
 */
export const useDisclosureStore = create<TDisclosureStore>((set, get) => ({
    ...initialState,
    ...createDisclosureActions(set, get),
}));
